module.exports = __webpack_public_path__ + "img/5.1c7e58de.png";